import { createContext, useEffect, useState } from "react";


export const CurrencyContext = createContext();

export default function CurrencyProvider({ children }) {

    const curre = localStorage.getItem('currency');
    const [currency, setCurrency] = useState(null);

    useEffect(() => {
        if (curre === null) {
            setCurrency({ name: "United States Dollar", symbol: "USD" });
            localStorage.setItem('currency', JSON.stringify({ name: "United States Dollar", symbol: "USD" }));
        } else {
            setCurrency(JSON.parse(curre));
        }
    }, [])


    const handlerCurrency = (currency) => {
        setCurrency(currency);
        localStorage.setItem('currency', JSON.stringify(currency));
    }


    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, handlerCurrency }}>
            {children}
        </CurrencyContext.Provider >
    )

};